class Navigation {
  constructor() {
    this.$masthead = document.querySelector(".c-masthead");
    this.$html = document.getElementsByTagName("html")[0];
    this.$footer = document.querySelector(".c-footer");
    this.$navigation = document.querySelector(".c-masthead__nav");
    this.$toggle = document.querySelector(".js-masthead__toggle");
    this.$search = document.querySelector(".c-masthead__search");
    this.$searchToggle = document.querySelector(".js-search__toggle");
    this.$searchField = document.querySelector(".c-search__field");

    this.setNavigation();
    this.initAriaState();
    requestAnimationFrame(() => this.scrollNavToActive());
  }

  scrollNavToActive() {
    const active = document.querySelector(".c-navigation a.is-active");
    if (!active) return;
    const nav = active.closest(".c-navigation ul");
    if (!nav) return;
    let offset = 0;
    let el = active;
    while (el && el !== nav) {
      offset += el.offsetLeft;
      el = el.offsetParent;
    }
    nav.scrollTo({ left: offset - (nav.offsetWidth - active.offsetWidth) / 2, behavior: "smooth" });
  }

  showNavigation() {
    this.$html.classList.add("has-masthead-open");
    this.$masthead.setAttribute("aria-expanded", "true");
    document.querySelector("#content").setAttribute("aria-hidden", "true");
    this.$footer.setAttribute("aria-hidden", "true");
    this.$navigation.setAttribute("aria-hidden", "false");
    this.trapFocus(this.$navigation);
    this.$toggle.focus();
  }

  hideNavgigation() {
    this.$html.classList.remove("has-masthead-open");
    this.$masthead.setAttribute("aria-expanded", "false");
    document.querySelector("#content").setAttribute("aria-hidden", "false");
    this.$footer.setAttribute("aria-hidden", "false");
    this.$navigation.setAttribute("aria-hidden", "true");
  }

  showSearch() {
    this.$html.classList.add("has-search-open");
    this.$masthead.setAttribute("aria-expanded", "true");
    document.querySelector("#content").setAttribute("aria-hidden", "true");
    this.$footer.setAttribute("aria-hidden", "true");
    this.$navigation.setAttribute("aria-hidden", "false");
    this.trapFocus(this.$search);
    this.$searchField.focus();
  }

  hideSearch() {
    this.$html.classList.remove("has-search-open");
    this.$masthead.setAttribute("aria-expanded", "false");
    document.querySelector("#content").setAttribute("aria-hidden", "false");
    this.$footer.setAttribute("aria-hidden", "false");
    this.$navigation.setAttribute("aria-hidden", "true");
    this.$searchField.blur();
  }

  escapeModal(Event) {
    if (Event.key === "Escape") {
      this.hideNavgigation();
      this.hideSearch();
    }
  }

  trapFocus(modal) {
    const focusableElements =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const $modal = modal;
    const $firstFocusableElement =
      $modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
    const $focusableContent = $modal.querySelectorAll(focusableElements);
    const $lastFocusableElement =
      $focusableContent[$focusableContent.length - 1]; // get last element to be focused inside modal
    const $toggle = this.$toggle;

    function setTrapFocus(Event) {
      let isTabPressed = Event.key === "Tab" || Event.keyCode === 9;

      if (!isTabPressed) {
        return;
      }

      if (Event.shiftKey) {
        // if shift key pressed for shift + tab combination
        if (document.activeElement === $toggle) {
          $lastFocusableElement.focus(); // add focus for the last focusable element
          Event.preventDefault();
        }
        else if (document.activeElement === $firstFocusableElement) {
          $toggle.focus();
          Event.preventDefault();
        }
      } else {
        // if tab key is pressed
        if (document.activeElement === $lastFocusableElement) {
          // if focused has reached to last focusable element then focus first focusable element after pressing tab
          $toggle.focus(); // add focus for the first focusable element
          Event.preventDefault();
        }
      }
    }

    document.addEventListener("keydown", (event) => {
      setTrapFocus(event);
    });
  }

  isDesktop() {
    return window.matchMedia('(min-width: 1025px)').matches;
  }

  initAriaState() {
    if (!this.isDesktop()) {
      this.$navigation.setAttribute('aria-hidden', 'true');
      this.$toggle.setAttribute('aria-expanded', 'false');
    }
  }

  toggleNavigation() {
    // Nav is always visible on desktop — hamburger is hidden via CSS, guard defensively
    if (this.isDesktop()) return;

    // Checks if already opened, then closes
    if (this.$html.classList.contains("has-masthead-open")) {
      this.hideNavgigation();
    }
    // Checks if search is opened, then closes it
    else if (this.$html.classList.contains("has-search-open")) {
      this.hideSearch();
      this.hideNavgigation();
    }
    // Opens the menu
    else {
      this.showNavigation();
    }
  }

  toggleSearch() {
    // Checks if already opened, then closes
    if (this.$html.classList.contains("has-search-open")) {
      this.hideSearch();
    }
    // Checks if masthead is opened, then closes it
    else if (this.$html.classList.contains("has-masthead-open")) {
      this.hideNavgigation();
      this.showSearch();
    }
    // Opens the menu
    else {
      this.showSearch();
    }
  }

  setNavigation() {
    document.addEventListener("keyup", (event) => {
      this.escapeModal(event);
    });
    this.$toggle.addEventListener("click", () => {
      this.toggleNavigation();
    });
    if (this.$searchToggle) {
      this.$searchToggle.addEventListener("click", () => {
        this.toggleSearch();
      });
    }

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (this.isDesktop()) {
          this.$navigation.setAttribute('aria-hidden', 'false');
          if (this.$html.classList.contains('has-masthead-open')) {
            this.hideNavgigation();
          }
        } else {
          if (!this.$html.classList.contains('has-masthead-open')) {
            this.$navigation.setAttribute('aria-hidden', 'true');
          }
        }
      }, 100);
    });
  }
}

export default Navigation;
